import imdbIcon from "@public/img/imdb.svg";
import playIcon from "@public/img/play.svg";
import arrowRightIcon from "@public/img/arrow-right.svg";
import arrowLeftIcon from "@public/img/arrow-left.svg";
import { Movie } from "@/entry/server/movie";
import React, { useEffect, useRef, useState } from "react";
import { ASSETS_BASE_URL } from "@/utils/constants";
import { Link } from "react-router-dom";
import "@/styles/slider.css";

type SliderProps = {
  movies: Movie[];
};

function resolveBannerSrc(banner: string | undefined): string {
  if (!banner) {
    return "";
  }
  if (banner.indexOf("http") === 0) {
    return banner;
  }
  return ASSETS_BASE_URL + banner;
}

function Slider({ movies }: SliderProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const firstMovie = movies && movies.length > 0 ? movies[0] : null;
  const [bannerSrc, setBannerSrc] = useState<string>(
    firstMovie ? resolveBannerSrc(firstMovie.banner) : ""
  );

  var currentMovie = movies[currentIndex];

  const startInterval = function () {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(function () {
      setCurrentIndex(function (prevIndex) {
        return (prevIndex + 1) % movies.length;
      });
    }, 5000);
  };

  useEffect(function () {
    if (!movies.length || !movies[currentIndex]) {
      return;
    }

    setBannerSrc(resolveBannerSrc(movies[currentIndex].banner));
  }, [currentIndex, movies]);

  useEffect(function () {
    if (!movies.length) {
      return;
    }

    startInterval();

    return function () {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [movies.length]);

  if (!movies.length || !currentMovie) {
    return null;
  }

  const getNextMovie = function () {
    setCurrentIndex(function (prevIndex) {
      return (prevIndex + 1) % movies.length;
    });
    startInterval();
  };

  const getPreviousMovie = function () {
    setCurrentIndex(function (prevIndex) {
      return (prevIndex - 1 + movies.length) % movies.length;
    });
    startInterval();
  };

  var genres = currentMovie.genres ? currentMovie.genres : [];

  return (
    <section className="slider-hero mx-auto w-full text-slate-100">
      <img
        src={bannerSrc}
        alt={currentMovie.title}
        className="slider-hero__banner object-cover"
      />
      <div className="slider-hero__overlay bg-linear-to-t lg:bg-linear-to-l from-main-bg/95 via-main-bg/45 to-transparent" />

      <div className="slider-hero__content container mx-auto px-5 lg:px-0">
        <div className="slider-hero__text-block">
          <div className="slider-hero__meta">
            <div className="slider-hero__imdb text-sm">
              <span>{currentMovie.imdb_rate}/10</span>
              <img src={imdbIcon} alt="IMDb" />
            </div>
            <p className="text-center text-5xl leading-tight font-black lg:text-start">{currentMovie.title}</p>
            <p className="text-center text-xl font-bold lg:text-start">{currentMovie.fa_title}</p>
          </div>

          <div className="slider-hero__genres">
            {genres.map(function (genre, index) {
              return (
                <span
                  key={genre + "-" + index}
                  className="rounded-full border border-slate-200 bg-main-bg/50 px-2.5 py-0.5 text-xs font-semibold"
                >
                  {genre}
                </span>
              );
            })}
          </div>

          <Link
            to={"/" + currentMovie.type + "/" + currentMovie.id + "/" + currentMovie.slug + "/"}
            className="slider-hero__play-btn slider-hero__play-desktop h-10 max-w-[260px] rounded-lg bg-lime-400 px-4 text-sm text-zinc-900"
          >
            <img src={playIcon} alt="" />
            دیدن فیلم
          </Link>
        </div>

        <div className="slider-hero__controls">
          <button
            type="button"
            className="slider-hero__nav-btn"
            onClick={getPreviousMovie}
            aria-label="قبلی"
          >
            <img src={arrowRightIcon} alt="" />
          </button>

          <Link
            to={"/" + currentMovie.type + "/" + currentMovie.id + "/" + currentMovie.slug + "/"}
            className="slider-hero__play-btn slider-hero__play-mobile h-10 rounded-lg bg-lime-400 px-4 text-sm text-zinc-900"
          >
            <img src={playIcon} alt="" />
            دیدن فیلم
          </Link>

          <button
            type="button"
            className="slider-hero__nav-btn"
            onClick={getNextMovie}
            aria-label="بعدی"
          >
            <img src={arrowLeftIcon} alt="" />
          </button>
        </div>
      </div>
    </section>
  );
}

export default Slider;
